import React from 'react';

// Original svg is in this folder

const SRMIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 38.5 16.1" {...props}>
		<g>
			<rect x="3.4" y="0.3" fill="#018346" width="34.7" height="12.9" />
			<rect x="2" y="1.3" fill="#01C56A" width="34.7" height="12.9" />
			<rect x="0.6" y="2.6" fill="#00F181" width="34.7" height="13" />
		</g>
		<g>
			<path
				d="M6.6,12.9C6,12.5,5.8,12,5.8,11.3c0-0.1,0-0.2,0-0.3l0-0.3c0,0,0-0.1,0.1-0.1s0.1,0,0.1,0h1.2c0,0,0.1,0,0.1,0s0,0.1,0,0.1
            l0,0.2l0,0.1c0,0.4,0.2,0.6,0.5,0.9c0.3,0.2,0.8,0.3,1.3,0.3c0.6,0,1-0.1,1.3-0.4c0.3-0.3,0.5-0.6,0.5-1c0-0.3-0.1-0.5-0.4-0.7
            S9.7,9.8,9,9.5C8.4,9.3,8,9.1,7.7,9C7.3,8.8,7,8.5,6.8,8.3C6.6,8,6.5,7.6,6.5,7.2c0-0.6,0.1-1,0.4-1.5c0.3-0.4,0.7-0.7,1.2-1
            c0.5-0.2,1.1-0.3,1.8-0.3c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.7c0,0.1,0,0.2,0,0.3l0,0.2c0,0,0,0.1-0.1,0.1s-0.1,0-0.1,0
            h-1.2c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1l0-0.1l0-0.2c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.7-0.4-1.3-0.4c-0.5,0-0.9,0.1-1.2,0.3
            S8,6.6,8,7C8,7.2,8,7.4,8.2,7.5c0.1,0.1,0.3,0.3,0.6,0.4C9,8,9.4,8.2,9.9,8.4c0.5,0.2,1,0.4,1.3,0.6c0.3,0.2,0.6,0.4,0.8,0.7
            s0.3,0.6,0.3,1.1c0,0.1,0,0.2,0,0.3c-0.1,0.8-0.5,1.4-1.1,1.8c-0.6,0.4-1.4,0.7-2.5,0.7C7.9,13.5,7.1,13.3,6.6,12.9z"
			/>
			<path
				d="M18.4,13.3l-1.2-3.6c0,0,0,0,0,0c0,0,0,0,0,0h-1.6c0,0-0.1,0-0.1,0.1L15,13.3c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-1.2
            c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1l1.1-8.6c0,0,0-0.1,0.1-0.1s0.1,0,0.1,0h3.6c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,0.9,0.6,1.6
            c0,0.1,0,0.2,0,0.4c-0.1,0.6-0.3,1.1-0.7,1.5c-0.4,0.4-0.8,0.7-1.4,0.9c0,0-0.1,0-0.1,0.1l1.4,3.7c0,0,0,0,0,0.1
            c0,0.1,0,0.1-0.1,0.1h-1.2C18.5,13.4,18.4,13.4,18.4,13.3z M16,5.8C15.9,5.9,15.9,5.9,16,5.8l-0.3,2.6c0,0,0,0.1,0.1,0.1h1.9
            c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1.1c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3L16,5.8C16,5.8,16,5.8,16,5.8z"
			/>
			<path
				d="M28.5,4.6h1.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1l-1.1,8.6c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-1.2c0,0-0.1,0-0.1,0
            c0,0,0-0.1,0-0.1l0.8-6c0,0,0,0,0-0.1c0,0,0,0-0.1,0L26,9.6c0,0.1-0.1,0.1-0.2,0.1h-0.6c-0.1,0-0.1,0-0.2-0.1l-1.3-2.4c0,0,0,0,0,0
            c0,0,0,0,0,0.1l-0.8,6c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-1.2c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1l1.1-8.6c0,0,0-0.1,0.1-0.1
            s0.1,0,0.1,0h1.2c0.1,0,0.1,0,0.2,0.1l1.7,3.1c0,0,0,0,0,0c0,0,0,0,0,0l2.5-3.1C28.4,4.6,28.4,4.6,28.5,4.6z"
			/>
		</g>
	</svg>
);

export default SRMIcon;
